// libs
import { Context, createContext } from 'react';
import { INITIAL_CONTEXT } from './initial-context.constant';
import { IDialogContext } from './dialog.context.interface';

export function createDialogContext<Data = unknown>(): Context<IDialogContext<Data>> {
  return createContext<IDialogContext<Data>>(INITIAL_CONTEXT as IDialogContext<Data>);
}

export default createDialogContext;
